// extracted by mini-css-extract-plugin
export var bodyRow = "_g5-d";
export var cardColumns = "_g5-e";
export var ellipsesOverflow = "_g5-2";
export var flatBottomCorners = "_g5-3";
export var flatTopCorners = "_g5-4";
export var headerActionsDropdown = "_g5-f";
export var headerBottomRow = "_g5-c";
export var headerTopRow = "_g5-b";
export var orderDetailsWrapper = "_g5-0";
export var orderInfoContainer = "_g5-1";
export var productDetails = "_g5-9";
export var productImage = "_g5-5";
export var responsiveTable = "_g5-8";
export var shipmentContainer = "_g5-a";
export var tableBottomLeft = "_g5-6";
export var tableBottomRight = "_g5-7";
export var trackingLink = "_g5-g";